import { getCurrentUserEmail, getCurrentUserName } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';
// Added by Vinaya - KMS encryption for mobile number (PII)
import kmsEncryption from '../kmsEncryption';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

// Modified by Vinaya - Made async to support KMS encryption of mobile number
export const buildD1Payload = async ({
  members = [],
  deletedMembers = [],
  currentUserEmail = getCurrentUserEmail(),
  currentUserName = getCurrentUserName(),
  eightDInfoId,
}) => {
  const nowIso = new Date().toISOString();
  const finalEightDInfoId = eightDInfoId || getEightDInfoId();

  const teamMembers = await Promise.all((members || []).map(async (m, idx) => {
    const badge = (m.role || '').trim().toLowerCase();
    const memberRole = badge === 'o' ? 'Originator' : (m.memberRole || 'Team Member');

    // Added by Vinaya - Encrypt mobile number using KMS before sending to API
    const encryptedMobile = (m.mobile || '').trim()
      ? await kmsEncryption.encryptField((m.mobile || '').trim())
      : '';

    const payload = {
      D1Id: m.d1Id || null,
      EightDInfoId: finalEightDInfoId,
      TeamMemberName: (m.name || '').trim(),
      EmailId: (m.email || '').trim().toLowerCase(),
      MobileNo: encryptedMobile,
      MemberRole: memberRole,
      IsClosureMailSent: false,
      IsDeleted: false,
      // Added by Vinaya - Include encrypted data key for server-side decryption
      EncryptedDataKey: kmsEncryption.getEncryptedDataKey(),
      ModifiedBy: currentUserEmail || 'string',
      ModifiedOn: nowIso
    };

    if (!m.d1Id) {
      payload.CreatedBy = currentUserEmail || 'string';
      payload.CreatedOn = nowIso;
    } else {
      payload.CreatedBy = m.createdBy || currentUserEmail || 'string';
      payload.CreatedOn = m.createdOn || nowIso;
    }

    return payload;
  }));

  // Append deleted members with IsDeleted: true
  const deletedPayloads = (deletedMembers || []).filter(m => m.d1Id).map(m => ({
    D1Id: m.d1Id,
    EightDInfoId: finalEightDInfoId,
    TeamMemberName: (m.name || '').trim(),
    EmailId: (m.email || '').trim().toLowerCase(),
    MobileNo: (m.mobile || '').trim(),
    MemberRole: m.role === 'o' ? 'Originator' : (m.memberRole || 'Team Member'),
    IsClosureMailSent: false,
    IsDeleted: true,
    CreatedBy: m.createdBy || currentUserEmail || 'string',
    CreatedOn: m.createdOn || nowIso,
    ModifiedBy: currentUserEmail || 'string',
    ModifiedOn: nowIso
  }));

  return [...teamMembers, ...deletedPayloads];
};
